import { useState, useEffect } from "react";

export const useTheme = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem("gc_theme") || "light");
  useEffect(() => {
    document.documentElement.classList.toggle("theme-light", theme === "light");
    localStorage.setItem("gc_theme", theme);
  }, [theme]);
  const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));
  return [theme, toggleTheme];
};
